import { Injectable } from '@angular/core';
import {BehaviorSubject, catchError, map, Observable, of, take} from "rxjs";
import {GET_USER_INFO} from "../queriesInternal/GET_USER_INFO";
import {UserInfo} from "../interfaces/user-info";
import {Apollo, QueryRef} from "apollo-angular";
import {AuthService} from "../auth/auth.service";
import {GET_SCHOOL_CLASSES_BY_USER} from "../queries/GET_SCHOOL_CLASSES_BY_USER";
import {GET_SCHOOL_TEACHERS} from "../queries/GET_SCHOOL_TEACHERS";
import {GET_GAME_TIMERS_SCHOOL} from "../queries/GET_GAME_TIMERS_SCHOOL";
import {GET_GAME_CATEGORIES_PER_GAME} from "../queries/GET_GAME_CATEGORIES_PER_GAME";
import {GET_COMPANY_PROFILE_QUIZ_QUESTIONS} from "../queries/GET_COMPANY_PROFILE_QUIZ_QUESTIONS";

@Injectable({
  providedIn: 'root'
})
export class WatchDataService {

  constructor(
    private apollo: Apollo,
    private authService: AuthService
  ) { }

  getUserInfoQuery?: QueryRef<any>;
  getUserInfoSubject: BehaviorSubject<UserInfo | undefined> = new BehaviorSubject<UserInfo | undefined>(undefined);
  getUserInfo() {
    this.authService.isAuthenticated$.subscribe(isAuthenticated => {
      if(isAuthenticated) {
        this.getUserInfoQuery = this.apollo
          .use("internalClient")
          .watchQuery<any>({
            query: GET_USER_INFO
          });

        this.getUserInfoQuery
          ?.valueChanges
          .pipe(catchError((err, caught) => { // TODO: @Florian since getUserInfo() method calls in app.component on app start, we can check whether access_token valid or not, if not then just logout
            if(err.toString().indexOf('401') !== -1) {
              console.log("Can't authorize user info graphql request, log out...");
              this.authService.logout();
            }

            return of({data: null, loading: false});
          }))
          .subscribe(({data, loading}) => {
            if(data) {
              let userInfo: UserInfo = {
                title: data.userinfo?.title ?? {},
                firstName: data.userinfo?.firstname ?? "",
                lastName: data.userinfo?.lastname ?? "",
                id: data.userinfo?.id ?? 0,
                userName: data.userinfo?.username ?? "",
                roles: data.userinfo?.roles?.map((role: any) => role.roleName) ?? [],
                email: data.userinfo?.email ?? "",
                avatarSrc: ""
              }

              this.getUserInfoSubject.next(userInfo);
            } else {
              this.getUserInfoSubject.next(undefined);
            }
          });
      } else {
        this.getUserInfoSubject.next(undefined);
      }
    });
  }



  getSchoolClassesByUserSubject = new BehaviorSubject<any>(null);
  getSchoolClassesByUserQuery?: QueryRef<any>;
  getSchoolClassesByActiveUser() {

    if(this.getSchoolClassesByUserQuery) {
      return;
    }

    this.getSchoolClassesByUserQuery = this.apollo
      .use("internalClient")
      .watchQuery<any>({
        query: GET_SCHOOL_CLASSES_BY_USER,
        fetchPolicy: "no-cache",
      });

    this.getSchoolClassesByUserQuery
      .valueChanges
      .pipe(map((data: any) => {
        return data.data.getSchoolClassesByUser
      }))
      .subscribe(result => {
        this.getSchoolClassesByUserSubject.next(result);
      });

  }


  getSchoolTeachersSubject = new BehaviorSubject<any>(null);
  getSchoolTeachersQuery?: QueryRef<any>;
  getSchoolTeachers() {
      this.getSchoolTeachersQuery = this.apollo
        .use("internalClient")
        .watchQuery<any>({
          query: GET_SCHOOL_TEACHERS,
          fetchPolicy: "no-cache",
        });

      this.getSchoolTeachersQuery
        .valueChanges
        .subscribe(({data, loading}) => {
          if(data.getSchoolTeachers){
            // console.log("data.getSchoolTeachers", data.getSchoolTeachers);
            this.getSchoolTeachersSubject.next(data.getSchoolTeachers);
          } else {
            this.getSchoolTeachersSubject.next(undefined);
          }
        })
  }

  getGameTimersSchoolSubject = new BehaviorSubject<any>(null);
  getGameTimersSchoolQuery?: QueryRef<any>;

  getGameTimersSchool(schoolId: number) {

    this.getGameTimersSchoolQuery = this.apollo
      .watchQuery<any>({
        query: GET_GAME_TIMERS_SCHOOL,
        variables: {
          schoolId
        },
        fetchPolicy: "no-cache",
      });

    this.getGameTimersSchoolQuery
      .valueChanges
      .subscribe(({data, loading}) => {
        if(data.getGameTimersSchool) {
          this.getGameTimersSchoolSubject.next(data.getGameTimersSchool);
        } else {
          this.getGameTimersSchoolSubject.next(undefined);
        }
      })

  }

  getGameCategoriesPerGameSubject = new BehaviorSubject<any>(null);
  getGameCategoriesPerGameQuery?: QueryRef<any>;

  getGameCategoriesPerGame(clientId: string) {

    this.getGameCategoriesPerGameQuery = this.apollo
      .watchQuery<any>({
        query: GET_GAME_CATEGORIES_PER_GAME,
        variables: {
          clientId
        },
        fetchPolicy: "no-cache",
      });

    this.getGameCategoriesPerGameQuery
      .valueChanges
      .subscribe(({data, loading}) => {
        if(data.getGameCategoriesPerGame) {
          this.getGameCategoriesPerGameSubject.next(data.getGameCategoriesPerGame);
        } else {
          this.getGameCategoriesPerGameSubject.next(undefined);
        }
      })

  }

  getCompanyQuizQuestionsSubject = new BehaviorSubject<any>(null);
  getCompanyQuizQuestionsQuery?: QueryRef<any>;

  getCompanyProfileQuizQuestions() {

    this.getCompanyQuizQuestionsQuery = this.apollo
      .use("internalClient")
      .watchQuery<any>({
        query: GET_COMPANY_PROFILE_QUIZ_QUESTIONS,
        fetchPolicy: "no-cache",
      });

    this.getCompanyQuizQuestionsQuery
      .valueChanges
      .subscribe(({data, loading}) => {
        if(data.getCompanyProfileQuizQuestions) {
          this.getCompanyQuizQuestionsSubject.next(data.getCompanyProfileQuizQuestions);
        } else {
          this.getCompanyQuizQuestionsSubject.next(undefined);
        }
      })

  }


}
